/* IVS Security — Cash on Delivery order form
   Modes: worker (direct Shopify order via your endpoint), checkout (Shopify checkout), whatsapp (message). */
(function () {
  'use strict';
  if (window.customElements && customElements.get('cod-form')) return;

  function money(cents) {
    return window.IVS && IVS.formatMoney ? IVS.formatMoney(cents) : 'Rs ' + Math.round(cents / 100).toLocaleString('en-US');
  }
  function fill(template, map) {
    return String(template || '').replace(/\{(\w+)\}/g, function (m, k) { return map[k] !== undefined ? map[k] : m; });
  }
  function track(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, data);
    } catch (e) { /* analytics must never break the form */ }
  }
  function normalizePhone(v, format) {
    var d = String(v || '').replace(/[^\d+]/g, '');
    if (format === 'any') return d.replace(/\D/g, '').length >= 7 ? d : null;
    if (/^\+923\d{9}$/.test(d)) return d;
    if (/^923\d{9}$/.test(d)) return '+' + d;
    if (/^03\d{9}$/.test(d)) return '+92' + d.slice(1);
    if (/^3\d{9}$/.test(d)) return '+92' + d;
    return null;
  }

  class CodForm extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      try { this.cfg = JSON.parse(this.querySelector('[data-cod-config]').textContent); } catch (e) { return; }
      this.form = this.querySelector('form');
      this.started = false;
      // Direct mode without an endpoint yet: fall back to WhatsApp so no order is lost
      if (this.cfg.mode === 'worker' && !this.cfg.endpoint) this.cfg.mode = 'whatsapp';
      this.setAttribute('data-mode', this.cfg.mode);
      this.variantId = this.cfg.variantId;

      this.form.addEventListener('change', this.render.bind(this));
      this.form.addEventListener('input', (e) => { if (e.target.matches('[data-cam-qty],[name="quantity"],[name="city"]')) this.render(); });
      this.form.addEventListener('submit', this.submit.bind(this));
      this.form.addEventListener('focusin', () => {
        if (this.started) return;
        this.started = true;
        track('ivs_cod_start', { value: this.totals().total / 100, currency: (window.IVS && IVS.currency) || 'PKR', product: this.cfg.product.title });
      });

      document.addEventListener('ivs:variant-change', (e) => {
        const section = e.detail && e.detail.section;
        if (section && section !== document && !section.contains(this)) return;
        if (e.detail.variant) this.variantId = e.detail.variant.id;
        this.render();
      });

      // details are not needed for Shopify checkout (customer fills them there)
      if (this.cfg.mode === 'checkout') {
        const details = this.querySelector('[data-details]');
        if (details) details.hidden = true;
      }
      this.querySelector('[data-submit-label]').textContent =
        this.cfg.mode === 'checkout' ? this.cfg.text.buttonCheckout :
        this.cfg.mode === 'whatsapp' ? this.cfg.text.buttonWhatsapp : this.cfg.text.button;

      this.render();
    }

    variant() {
      return this.cfg.variants.find((v) => String(v.id) === String(this.variantId)) || this.cfg.variants[0];
    }
    offer() {
      const el = this.form.querySelector('input[name="offer"]:checked');
      if (!el) {
        const q = this.form.querySelector('input[name="quantity"]');
        return { qty: Math.max(1, Number(q ? q.value : 1) || 1), percent: 0, code: '', title: '' };
      }
      return { qty: Number(el.dataset.qty) || 1, percent: Number(el.dataset.percent) || 0, code: el.dataset.code || '', title: el.dataset.title || '' };
    }
    upsells() {
      return Array.from(this.form.querySelectorAll('input[name="upsell"]:checked, input[name="memcard"]:checked'))
        .filter((el) => el.value)
        .map((el) => ({ variantId: el.value, price: Number(el.dataset.price) || 0, title: el.dataset.title }));
    }
    cameras() {
      return Array.from(this.querySelectorAll('[data-cam]')).map((row) => ({
        title: row.dataset.title, qty: Math.max(0, Number(row.querySelector('[data-cam-qty]').value) || 0)
      }));
    }
    unitAfter(priceCents, percent) {
      // Same rounding as the Worker: whole rupees
      return Math.round((priceCents / 100) * (1 - percent / 100)) * 100;
    }
    totals() {
      const v = this.variant();
      const o = this.offer();
      const line = this.unitAfter(v.price, o.percent) * o.qty;
      const extras = this.upsells().reduce((s, u) => s + u.price, 0);
      let fee = this.cfg.mode === 'checkout' ? 0 : Math.max(0, Number(this.cfg.deliveryFee) || 0) * 100;
      let feePending = false;
      const free = (this.cfg.freeCities || []).map((c) => String(c).trim().toLowerCase()).filter(Boolean);
      // free delivery only in the listed cities, and only from the minimum order amount
      const reachedMin = (line + extras) >= Math.max(0, Number(this.cfg.freeMin) || 0) * 100;
      if (fee > 0 && free.length && reachedMin) {
        const cityEl = this.form.querySelector('[name="city"]');
        const city = (cityEl ? cityEl.value : '').trim().toLowerCase();
        if (!city) { fee = 0; feePending = true; }
        else if (free.some((c) => city.indexOf(c) !== -1 || c.indexOf(city) !== -1 && city.length >= 3)) fee = 0;
      }
      return { line: line, extras: extras, fee: fee, feePending: feePending, total: line + extras + fee, full: v.price * o.qty };
    }

    render() {
      const v = this.variant();
      // offer prices
      this.form.querySelectorAll('input[name="offer"]').forEach((el) => {
        const label = el.closest('.cod__offer');
        const qty = Number(el.dataset.qty) || 1;
        const pct = Number(el.dataset.percent) || 0;
        const now = this.unitAfter(v.price, pct) * qty;
        const was = Math.max(v.compare > v.price ? v.compare : v.price, v.price) * qty;
        label.querySelector('[data-offer-price]').textContent = money(now);
        const s = label.querySelector('[data-offer-compare]');
        s.textContent = was > now ? money(was) : '';
      });
      // camera chooser
      const camsWrap = this.querySelector('[data-cams]');
      if (camsWrap) {
        const need = this.cfg.cameraCount;
        const rows = this.cameras();
        let sum = rows.reduce((s, r) => s + r.qty, 0);
        // never allow more than needed: clamp the input that changed last
        if (sum > need) {
          const inputs = Array.from(this.querySelectorAll('[data-cam-qty]'));
          const active = document.activeElement && document.activeElement.closest ? document.activeElement.closest('[data-cam]') : null;
          let target = active ? active.querySelector('[data-cam-qty]') : null;
          if (!target) target = inputs.reverse().find((i) => Number(i.value) > 0);
          if (target) target.value = Math.max(0, Number(target.value) - (sum - need));
          sum = need;
        }
        this.querySelectorAll('[data-cam]').forEach((row) => {
          const plus = row.querySelector('[data-qty-btn="plus"]');
          if (plus) plus.disabled = sum >= need;
        });
        camsWrap.querySelector('[data-cams-selected]').textContent = sum;
        camsWrap.querySelector('[data-cams-bar]').style.width = Math.min(100, (sum / need) * 100) + '%';
        camsWrap.classList.toggle('is-complete', sum === need);
      }
      // totals
      const t = this.totals();
      this.querySelector('[data-subtotal]').textContent = money(t.line + t.extras);
      const d = this.querySelector('[data-delivery]');
      d.textContent = this.cfg.mode === 'checkout' ? this.cfg.text.calculated : (t.feePending && this.cfg.feeHint ? this.cfg.feeHint : (t.fee > 0 ? money(t.fee) : this.cfg.freeLabel));
      d.classList.toggle('is-free', this.cfg.mode !== 'checkout' && t.fee === 0 && !t.feePending);
      this.querySelector('[data-total]').textContent = money(t.total);
      // availability
      const btn = this.querySelector('[data-submit]');
      btn.disabled = !v.available;
      if (!v.available) this.querySelector('[data-submit-label]').textContent = this.cfg.text.soldOut;
    }

    error(msg, field) {
      const p = this.querySelector('[data-error]');
      p.textContent = msg || '';
      p.hidden = !msg;
      if (field) field.focus();
    }

    collect() {
      const f = this.form.elements;
      const val = (n) => (f[n] ? String(f[n].value || '').trim() : '');
      return {
        name: val('name'), phoneRaw: val('phone'), city: val('city'), area: val('area'),
        address: val('address'), email: val('email'), notes: val('notes'), website: val('website')
      };
    }

    validate(data) {
      const f = this.form.elements;
      ['name', 'phone', 'city', 'address'].forEach((n) => f[n] && f[n].setAttribute('aria-invalid', 'false'));
      if (this.cfg.cameraCount > 0) {
        const sum = this.cameras().reduce((s, r) => s + r.qty, 0);
        if (sum !== this.cfg.cameraCount) {
          this.error(fill(this.cfg.text.errorCameras, { count: this.cfg.cameraCount, selected: sum }));
          const cams = this.querySelector('[data-cams]');
          if (cams) cams.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return false;
        }
      }
      if (this.cfg.mode === 'checkout') return true;
      const checks = [['name', data.name.length >= 2], ['phone', !!normalizePhone(data.phoneRaw, this.cfg.phoneFormat)], ['city', data.city.length >= 2], ['address', data.address.length >= 6]];
      for (const [n, ok] of checks) {
        if (!ok && f[n]) {
          f[n].setAttribute('aria-invalid', 'true');
          this.error(n === 'phone' ? this.cfg.text.errorPhone : this.cfg.text.errorFields, f[n]);
          return false;
        }
      }
      return true;
    }

    properties() {
      const props = [];
      const o = this.offer();
      if (o.title && o.percent > 0) props.push({ name: 'Offer', value: o.title + ' (' + o.percent + '% off)' });
      const cams = this.cameras().filter((c) => c.qty > 0);
      if (cams.length) props.push({ name: 'Cameras', value: cams.map((c) => c.qty + ' × ' + c.title).join(', ') });
      return props;
    }

    busy(on) {
      const btn = this.querySelector('[data-submit]');
      const label = this.querySelector('[data-submit-label]');
      if (on) { this._label = label.textContent; label.textContent = this.cfg.text.busy; btn.disabled = true; }
      else { label.textContent = this._label || this.cfg.text.button; btn.disabled = false; }
    }

    submit(e) {
      e.preventDefault();
      this.error('');
      const data = this.collect();
      if (!this.validate(data)) return;
      if (this.cfg.mode === 'checkout') return this.toCheckout();
      if (this.cfg.mode === 'whatsapp' || !this.cfg.endpoint) return this.toWhatsApp(data);
      return this.toWorker(data);
    }

    summaryLines(data, orderName) {
      const v = this.variant();
      const o = this.offer();
      const t = this.totals();
      const lines = [];
      lines.push('*New order' + (orderName ? ' ' + orderName : '') + '*');
      lines.push('Product: ' + this.cfg.product.title + (this.cfg.product.hasVariants ? ' (' + v.title + ')' : ''));
      lines.push('Quantity: ' + o.qty + (o.percent > 0 ? ' — ' + o.title + ', ' + o.percent + '% off' : ''));
      this.properties().forEach((p) => { if (p.name !== 'Offer') lines.push(p.name + ': ' + p.value); });
      const ups = this.upsells();
      if (ups.length) lines.push('Add-ons: ' + ups.map((u) => u.title).join(', '));
      lines.push('Delivery: ' + (t.fee > 0 ? money(t.fee) : this.cfg.freeLabel));
      lines.push('Total: ' + money(t.total) + ' (Cash on Delivery)');
      if (data) {
        lines.push('');
        lines.push('Name: ' + data.name);
        lines.push('Phone: ' + data.phoneRaw);
        lines.push('City: ' + data.city + (data.area ? ', ' + data.area : ''));
        lines.push('Address: ' + data.address);
        if (data.email) lines.push('Email: ' + data.email);
        if (data.notes) lines.push('Notes: ' + data.notes);
      }
      lines.push('');
      lines.push(this.cfg.product.url);
      return lines.join('\n');
    }

    toWhatsApp(data) {
      const url = 'https://wa.me/' + this.cfg.whatsapp + '?text=' + encodeURIComponent(this.summaryLines(data));
      track('ivs_cod_whatsapp', { value: this.totals().total / 100, currency: (window.IVS && IVS.currency) || 'PKR', product: this.cfg.product.title, content_ids: [String(this.variant().id)] });
      window.open(url, '_blank', 'noopener');
      this.success({ whatsappOnly: true, waUrl: url });
    }

    async toCheckout() {
      this.busy(true);
      const o = this.offer();
      const props = {};
      this.properties().forEach((p) => { props[p.name] = p.value; });
      const items = [{ id: Number(this.variant().id), quantity: o.qty, properties: props }];
      this.upsells().forEach((u) => items.push({ id: Number(u.variantId), quantity: 1 }));
      const routes = (window.IVS && IVS.routes) || {};
      try {
        await fetch((routes.cartClear || '/cart/clear') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } });
        const res = await fetch((routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items })
        });
        if (!res.ok) {
          const j = await res.json().catch(() => ({}));
          throw new Error(j.description || j.message || 'cart');
        }
        const root = (routes.root || '/').replace(/\/$/, '');
        window.location.href = o.code ? root + '/discount/' + encodeURIComponent(o.code) + '?redirect=' + encodeURIComponent(root + '/checkout') : root + '/checkout';
      } catch (err) {
        this.busy(false);
        this.error(err && err.message && err.message !== 'cart' ? err.message : this.cfg.text.errorServer);
      }
    }

    async toWorker(data) {
      this.busy(true);
      const o = this.offer();
      const payload = {
        variantId: String(this.variant().id),
        quantity: o.qty,
        offerPercent: o.percent,
        offerTitle: o.title,
        extras: this.upsells().map((u) => ({ variantId: String(u.variantId), quantity: 1 })),
        properties: this.properties(),
        name: data.name,
        phone: normalizePhone(data.phoneRaw, this.cfg.phoneFormat),
        city: data.city,
        area: data.area,
        address: data.address,
        email: data.email,
        notes: data.notes,
        website: data.website,
        source: this.cfg.product.url
      };
      try {
        const res = await fetch(this.cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
        const j = await res.json().catch(() => ({}));
        if (!res.ok || !j.ok) throw new Error(j.error || '');
        track('ivs_cod_purchase', {
          order_id: j.orderId, order_name: j.orderName, value: j.total, currency: (window.IVS && IVS.currency) || 'PKR',
          content_ids: [payload.variantId], quantity: payload.quantity, product: this.cfg.product.title
        });
        const totalText = money(Math.round(Number(j.total) * 100));
        const waText = fill(this.cfg.text.waConfirm, { order: j.orderName, product: this.cfg.product.title, total: totalText, name: data.name });
        this.success({ orderName: j.orderName, total: totalText, waUrl: 'https://wa.me/' + this.cfg.whatsapp + '?text=' + encodeURIComponent(waText) });
      } catch (err) {
        this.busy(false);
        this.error((err && err.message) || this.cfg.text.errorServer);
      }
    }

    success(info) {
      this.form.hidden = true;
      const box = this.querySelector('[data-success]');
      const text = info.whatsappOnly ? this.cfg.text.successWhatsapp : fill(this.cfg.text.successText, { order: info.orderName, total: info.total, product: this.cfg.product.title });
      box.querySelector('[data-success-text]').textContent = text;
      const wa = box.querySelector('[data-success-wa]');
      if (info.waUrl && this.cfg.whatsapp) wa.href = info.waUrl; else wa.hidden = true;
      box.hidden = false;
      box.focus({ preventScroll: true });
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  customElements.define('cod-form', CodForm);
})();
